import { FirstSamplePDF } from './FirstSamplePDF';
import { BlockSamplePDF } from './BlockSamplePDF';
import { ProtoSamplePDF } from './ProtoSamplePDF';
import { DefaultSamplePDF } from './DefaultSamplePDF';

import { SampleTagResponse } from '../types';

function SampleTagPDF({ tagData }: { tagData: SampleTagResponse }) {
  const sampleType = tagData?.type_of_sample_tag;

  const developmentType = tagData?.type_of_development;

  if (sampleType === 'First Sample') {
    return <FirstSamplePDF tagData={tagData} />;
  }

  if (sampleType === 'Block') {
    return <BlockSamplePDF tagData={tagData} />;
  }

  if (sampleType === 'Proto Development') {
    if (
      developmentType === 'Vendor Sample' ||
      developmentType === 'Buyer Requested' ||
      developmentType === 'LUXE'
    ) {
      return <ProtoSamplePDF tagData={tagData} />;
    }
  }

  return <DefaultSamplePDF tagData={tagData} />;
}

export default SampleTagPDF;
